export default __webpack_public_path__ + "static/media/good-4.b8ab7696.png";